<div class="pt-16 pl-32 pr-32">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
</div>

<div class="flex flex-row justify-between header-background mt--20">
  <div class="flex flex-row flex-auto pl-32 pt-16 pr-32 pb-16">
    <div class="flex flex-row pt-6">
      <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0"
        (click)="goToSchedule()"></mat-icon>
    </div>
    <div class="flex flex-col flex-auto justify-between pl-24">
      <div class="flex flex-row justify-between mb-8">
        <div class="mat-subtitle-1 fw-600 fs-20 mb-0">
              {{ isEditFlow ? ('SCHEDULE.EDIT_SCHEDULE' | transloco) : ('RUNBOOK.CREATE_SCHEDULE' | transloco) }}
        </div>
      </div>
      <div class="flex flex-row items-center mt--4">
        <div *ngIf="instance; else loader" class="fs-14 fw-400 pr-16 flex items-center">{{ 'INSTANCE_DETAILS.ENVIRONMENT_NAME' | transloco }}: <span class="ml-4">{{instance?.name}}</span></div>
        <div *ngIf="instance && ((createViaRunbook && createScheduleData?.name) || (!createViaRunbook && selectedRunbookName) || (isEditFlow || this.runbookForm?.get('runbookName')?.value?.name))" class="vertical-indicator-env ml-4"></div>
        <div *ngIf="instance && ((createViaRunbook && createScheduleData?.name) || (!createViaRunbook && selectedRunbookName) || (isEditFlow || this.runbookForm?.get('runbookName')?.value?.name))" class="flex flex-row justify-center items-center vertical-indicator fs-14 fw-400 ml-16 pr-16">
            {{ 'RUNBOOK.RUNBOOK_NAME' | transloco }}:  <span class="ml-4">{{ (createViaRunbook || isEditFlow) ? (createScheduleData?.name || this.runbookForm?.get('runbookName')?.value?.name || '-') : (selectedRunbookName || '-')}}</span>
        </div>
        <div *ngIf="instance && ((createViaRunbook && createScheduleData?.componentName) || (!createViaRunbook && selectedRunbookType))" class="flex flex-row justify-center items-center fs-14 fw-400 ml-16 pr-16">
            {{ 'RUNBOOK.ACTION' | transloco | titlecase }}:  <span class="ml-4">{{ selectedRunbookType || '-'}}</span> 
        </div>
          <ng-template #loader>
          <div class="pl-6 skeleton-loader pr-16">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="ml-32 mr-32">
  <div class="flex items-center steper-section mt-16 mb-16">
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === -1, 'visited': !detailsForm?.invalid && detailsForm?.touched}">
      <div class="flex flex-col items-center justify-center">
        <div class="border" [ngClass]="{'current-border': currentStep === -1, 'visited-border': !detailsForm?.invalid && detailsForm?.touched}"><div class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="(!detailsForm?.invalid && detailsForm?.touched) && currentStep !== -1" svgIcon="done" class="icon-sm"></mat-icon></div></div>
        <div class="mat-subtitle-2 mb-0 fs-14 mt-8 fw-500" [ngClass]="{'fw-600': currentStep === -1, 'default-style': currentStep !== -1 && !detailsForm?.touched}">{{'SCHEDULE_DETAILS.DETAIL'| transloco}}</div>
      </div>
      <span class="horizontal-line ml-12"></span>
    </div>
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 0, 'visited': !occurenceForm?.invalid && occurenceForm?.touched}">
      <div class="flex flex-col items-center justify-center">
        <div class="border" [ngClass]="{'current-border': currentStep === 0, 'visited-border': !occurenceForm?.invalid && occurenceForm?.touched}"><div class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="(!occurenceForm?.invalid && occurenceForm?.touched) && currentStep !== 0" svgIcon="done" class="icon-sm"></mat-icon></div></div>
        <div class="mat-subtitle-2 mb-0 fs-14 mt-8 fw-500" [ngClass]="{'fw-600': currentStep === 0, 'default-style': currentStep !== 0 && !occurenceForm?.touched}">{{'SCHEDULE_DETAILS.OCCURRENCE'| transloco}}</div>
      </div>
      <span class="horizontal-line ml-12"></span>
    </div>
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 1, 'visited': summaryVisited}">
      <div class="flex flex-col items-center justify-center">
        <div class="border" [ngClass]="{'current-border': currentStep === 1, 'visited-border': summaryVisited}"><div class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="summaryVisited && currentStep !== 1" svgIcon="done" class="icon-sm"></mat-icon></div></div>
        <div class="mat-subtitle-2 mb-0 fs-14 mt-8 fw-500" [ngClass]="{'fw-600': currentStep === 1, 'default-style': currentStep !== 1}">{{'RUNBOOK.RUNBOOK'| transloco}}</div>
      </div>
      <span class="horizontal-line ml-12"></span>
    </div>
        <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 2, 'visited': summaryVisited}">
      <div class="flex flex-col items-center justify-center">
        <div class="border" [ngClass]="{'current-border': currentStep === 2, 'visited-border': summaryVisited}"><div class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="summaryVisited && currentStep !== 2" svgIcon="done" class="icon-sm"></mat-icon></div></div>
        <div class="mat-subtitle-2 mb-0 fs-14 mt-8 fw-500" [ngClass]="{'fw-600': currentStep === 2, 'default-style': currentStep !== 2}">{{'INSTANCE_DETAILS.SUMMARY'| transloco}}</div>
      </div>
    </div>
  </div>

  @if (currentStep === -1) {
    <div class="section-border">
      <form [formGroup]="detailsForm" class="p-24">
        <div class="flex flex-row">
          <div class="flex flex-col mb-24 mr-32 name-field">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.SCHEDULE_NAME' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.NAME' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div class="flex flex-col mt-4">
              <input [readonly]="isEditFlow" [formControl]="detailsForm?.get('name')" class="name-container fw-400 h-34" placeholder="{{'INSTANCE_DETAILS.ENTER_NAME' | transloco}}" type="text">
              <app-error [control]="detailsForm?.get('name')"></app-error>
            </div>
          </div>
          <div class="flex flex-col mb-24 mr-32 description-field">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.DESCRIPTION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div class="flex flex-col mt-4">
              <input [readonly]="isEditFlow" [formControl]="detailsForm?.get('description')" class="name-container description fw-400 h-34" placeholder="{{'INSTANCE_DETAILS.DESCRIPTION_HERE' | transloco}}" type="text">
              <app-error [control]="detailsForm?.get('description')"></app-error>
            </div>
          </div>
        </div>
      </form>
    </div>

  } @else if (currentStep === 0) {
    <div class="section-border">
      <form [formGroup]="occurenceForm" class="p-24">
        <div class="flex flex-col">
            <div class="flex flex-row">
                <div *ngFor="let option of cronHeader" [ngClass]="{'disabled-cron': option.disabled}" class="flex flex-row items-center cursor-pointer p-6"
                    (click)="filterOptionChange(option)">
                    <mat-icon *ngIf="selectedFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                    <mat-icon *ngIf="selectedFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer"></mat-icon>
                    <span class="mat-body-1 fw-500 ml-6 mr-24 mb-0 primary-fg">
                    {{option.label}}
                    </span>
                </div>
            </div>
            <mat-divider class="mt-12 mb-12 mr-24 neutral-2"></mat-divider>
            <div class="flex flex-row mb-24">
                <div class="flex flex-col mr-24">
                    <div class="flex flex-row flex-wrap">
                        <label class="schedule-spacing fw-700 fs-12">{{'TEST_RESULTS.TIMEZONE' | transloco | uppercase}}</label>
                        <mat-icon class="icon-sm mt-4 ml-8" [matTooltip]="'TEST_RESULTS.TIMEZONE' | transloco | titlecase"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                    </div>
                    @if (isAWS) {
                        <input [value]="'UTC'" class="blend-border mt-4 blueprint-name disabled">
                    } @else {
                        <div>
                            <mat-select class="runbook-dropdown pt-0" (click)="resetTimezoneFilter()" [placeholder]="'SCHEDULE_DETAILS.CHOOSE_TIMEZONE' | transloco" [formControl]="occurenceForm?.get('timezoneId')" (selectionChange)="onTimezoneChange($event.value)" panelClass="runbook-dropdown" [matTooltip]="selectedTimezone?.displayName" matTooltipPosition="above">
                                <div class="flex search-bar m-8"><input [(ngModel)]="timezoneSearchValue" (ngModelChange)="searchTimezone($event)" [ngModelOptions]="{standalone: true}" class="fw-400 h-34 no-border pl-12" [placeholder]="'SEARCH.SEARCH' | transloco" type="text">
                                    <span (click)="searchTimezone(timezoneSearchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
                                </div>
                                <mat-option class="fs-14 flex justify-center" *ngIf="filteredTimezones?.length === 0">{{'SCHEDULE_DETAILS.NO_TIMEZONE_FOUND' | transloco}}</mat-option>
                                <ng-container *ngFor="let timezone of filteredTimezones">
                                    @if (timezone.displayName) {
                                        <mat-option [value]="timezone.id">{{timezone.displayName}}</mat-option>
                                        <mat-divider></mat-divider>
                                    }
                                </ng-container>
                            </mat-select>
                            <app-error [control]="occurenceForm?.get('timezoneId')"></app-error>
                        </div>
                    }
                </div>
                <div class="flex flex-col mr-12">
                    <div class="flex flex-row flex-wrap">
                        <label class="schedule-spacing fw-700 fs-12">{{'SCHEDULE_DETAILS.STARTDATE' | transloco | uppercase}}</label>
                        <mat-icon class="icon-sm mt-4 ml-8" [matTooltip]="'SCHEDULE_DETAILS.STARTDATE' | transloco | titlecase"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                    </div>
                    <div class="date-picker mt-4">
                        <app-datepicker [control]="occurenceForm?.get('startDate')" [placeholder]="'SCHEDULE_DETAILS.CHOOSE_STARTDATE' | transloco" (dateChange)="startDateChange($event)" class="datepicker" [min]="minDate" [max]="maxStartDate"></app-datepicker>
                        <app-error [control]="occurenceForm?.get('startDate')"></app-error>
                    </div>
                </div>
                <div class="flex flex-row">
                  <div class="flex flex-col mr-12">
                      <div class="flex flex-row flex-wrap mb-4">
                          <label class="schedule-spacing fw-700 fs-12">{{'SCHEDULE_DETAILS.HH' | transloco | uppercase}}</label>
                      </div>
                      <form>
                          <input [formControl]="occurenceForm?.get('sdHours')" value="0" type="number" id="hours" onKeyDown="return false" name="hours" min="0" max="23">
                      </form>
                  </div>
                  <div class="flex flex-col">
                      <div class="flex flex-row flex-wrap mb-4">
                          <label class="schedule-spacing fw-700 fs-12">{{'SCHEDULE_DETAILS.MM' | transloco | uppercase}}</label>
                      </div>
                      <form>
                          <input [formControl]="occurenceForm?.get('sdMinutes')" value="0" type="number" id="minutes" onKeyDown="return false" name="minutes" min="0" max="59">
                      </form>
                  </div>
              </div>
                <div class="flex flex-col ml-36 mr-12">
                    <div class="flex flex-row flex-wrap">
                        <label class="schedule-spacing fw-700 fs-12">{{'SCHEDULE_DETAILS.ENDDATE' | transloco | uppercase}}</label>
                        <mat-icon class="icon-sm mt-4 ml-8" [matTooltip]="'SCHEDULE_DETAILS.ENDDATE' | transloco | titlecase"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                    </div>
                    <div class="date-picker mt-4">
                        <app-datepicker [control]="occurenceForm?.get('endDate')" [placeholder]="'SCHEDULE_DETAILS.CHOOSE_ENDDATE' | transloco" class="datepicker" (dateChange)="endDateChange($event)" [min]="minEndDate"></app-datepicker>
                        <app-error [control]="occurenceForm?.get('endDate')"></app-error>
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="flex flex-col mr-12">
                        <div class="flex flex-row flex-wrap mb-4">
                            <label class="schedule-spacing fw-700 fs-12">{{'SCHEDULE_DETAILS.HH' | transloco | uppercase}}</label>
                        </div>
                        <form>
                            <input [formControl]="occurenceForm?.get('edHours')" value="0" type="number" id="hours" onKeyDown="return false" name="hours" min="0" max="23">
                        </form>
                    </div>
                    <div class="flex flex-col">
                        <div class="flex flex-row flex-wrap mb-4">
                            <label class="schedule-spacing fw-700 fs-12">{{'SCHEDULE_DETAILS.MM' | transloco | uppercase}}</label>
                        </div>
                        <form>
                            <input [formControl]="occurenceForm?.get('edMinutes')" value="0" type="number" id="minutes" onKeyDown="return false" name="minutes" min="0" max="59">
                        </form>
                    </div>
                </div>
            </div>
          <ng-container>
            <div class="flex flex-row mb-32">
                <div *ngIf="recurEvery" class="flex flex-col">
                    <div class="flex flex-row flex-wrap mb-4">
                        <label class="schedule-spacing fw-700 fs-12">{{'SCHEDULE_DETAILS.RECUR_EVERY' | transloco | uppercase}}</label>
                    </div>
                    <form>
                        <input [formControl]="occurenceForm?.get('recurDays')" value="1" type="number" id="recurDays" onKeyDown="return false" name="recurDays" min="1" max="30">
                    </form>
                </div>
            </div>
            <div class="flex flex-row" *ngIf="showDays">
                <div *ngFor="let item of days" class="mr-12">
                    <div class="flex flex-row w-100-percent mb-16" (click)="selectDays(item)">
                        <mat-icon [svgIcon]="item?.checked ? 'check_box' : 'check_box_outline_blank'" class="icon-md-1 mr-4 cursor-pointer"></mat-icon>
                        <span class="fw-400 fs-16">{{item.name}}</span>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="showMonths">
            <div class="flex flex-row">
                <div *ngFor="let item of months" class="mr-12">
                    <div class="flex flex-row w-100-percent mb-16" (click)="selectMonths(item)">
                        <mat-icon [svgIcon]="item?.checked ? 'check_box' : 'check_box_outline_blank'" class="icon-md-1 mr-4 cursor-pointer"></mat-icon>
                        <span class="fw-400 fs-16">{{item.name}}</span>
                    </div>
                </div>
            </div>
            <mat-divider class="mt-24 mr-24 neutral-2"></mat-divider>
            <div class="flex flex-row">
                <div *ngFor="let option of monthOptions" class="flex flex-row items-center cursor-pointer p-6"
                    (click)="filterMonthOptionChange(option)">
                    <mat-icon *ngIf="selectedMonthFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                    <mat-icon *ngIf="selectedMonthFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer"></mat-icon>
                    <span class="mat-body-1 fw-500 ml-6 mr-24 mb-0 primary-fg">
                    {{option.label}}
                    </span>
                </div>
            </div>
            <div *ngIf="daysSelect" class="flex flex-row mb-24 mt-16 day-field">
                <mat-select [placeholder]="'SCHEDULE_DETAILS.SELECT' | transloco" [formControl]="occurenceForm?.get('monthDays')" class="drop-down pt-0 form-select tenant-selections" #matSelect multiple>
                    <mat-option *ngFor="let tag of numbers" [value]="tag">{{tag}}</mat-option>
                </mat-select>
            </div>
            <div *ngIf="onSelect" class="flex flex-row">
                <div class="flex flex-col mb-24 mt-16 mr-24 day-field">
                    <mat-select class="drop-down pt-0 form-select tenant-selections" #matSelect [placeholder]="'SCHEDULE_DETAILS.SELECT' | transloco" [formControl]="occurenceForm?.get('onDays')" (selectionChange)="dayOptionSelected($event.value)">
                        <mat-option *ngFor="let tag of onDaysOptions" [value]="tag">{{tag.name}}</mat-option>
                    </mat-select>
                    <app-error [control]="occurenceForm?.get('onDays')"></app-error>
                </div>
                <div class="flex flex-col mb-24 mt-16 day-field">
                    <mat-select class="drop-down pt-0 form-select tenant-selections" #matSelect [placeholder]="'SCHEDULE_DETAILS.SELECT' | transloco" [formControl]="occurenceForm?.get('onSpecificDays')" (selectionChange)="specificDayOptionSelected($event.value)">
                        <mat-option *ngFor="let tag of onSpecificDaysOptions" [value]="tag">{{tag.name}}</mat-option>
                    </mat-select>
                    <app-error [control]="occurenceForm?.get('onSpecificDays')"></app-error>
                </div>
            </div>
            </ng-container>
            </ng-container>
        </div>

      </form>

    </div>

  } @else if (currentStep === 1) {
    <div class="section-border">
      <form [formGroup]="runbookForm" class="p-24">
        <div class="flex flex-row items-end">
          <div class="flex flex-col mb-24 mr-32">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'RUNBOOK.SELECT_RUNBOOK' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'RUNBOOK.SELECT_RUNBOOK' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div>
            <mat-select [ngClass]="{'dropdown-disabled': createViaRunbook || isEditFlow}" (closed)="dropdownClose()" class="runbook-dropdown pt-0" #matSelect [placeholder]="'RUNBOOK.CHOOSE_RUNBOOK' | transloco" [formControl]="runbookForm?.get('runbookName')" panelClass="runbook-dropdown" (click)="resetFilter()" (selectionChange)="onRunbookSelected($event.value)">
              <div *ngIf="!componentsLoading" class="flex search-bar m-8"><input [(ngModel)]="searchValue" (ngModelChange)="searchRunbookName(searchValue)" [ngModelOptions]="{standalone: true}" class="fw-400 h-34 no-border pl-12" placeholder="Search" type="text">
                <span (click)="searchRunbookName(searchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
              </div>
              <mat-option *ngIf="componentsLoading">
                <div class="flex items-center justify-center spinner-width mb-16 mt-16">
                  <mat-spinner class="mr-8" diameter="20"
                    color="primary"
                    mode="indeterminate">
                  </mat-spinner>
                </div>
              </mat-option>
              <mat-option class="fs-14 flex justify-center" *ngIf="!componentsLoading && filteredRunbooks?.length === 0">{{'RUNBOOK.NO_RUNBOOK_FOUND' | transloco}}</mat-option>
              <mat-option *ngFor="let runbook of filteredRunbooks" [value]="runbook">{{runbook.name}}</mat-option>
            </mat-select>
            </div>
            <app-error [control]="runbookForm?.get('runbookName')"></app-error>
          </div>
           <div *ngIf="runbookForm?.get('runbookName')?.value" class="pb-22 cursor-pointer view-details"
                    (click)="openRunbookDetails()">
            <span class="fw-500 fs-16 primary-fg underline">{{'INSTANCE_DETAILS.VIEW_DETAILS' | transloco}}</span>
            </div>
        </div>

        <!-- hiding as this is not needed -->
        <!-- <div class="flex flex-row">
          <div class="flex flex-col mb-24 mr-32">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.ACTIONS' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.ACTIONS' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div [ngClass]="{'input-disabled': createViaRunbook}">
            <mat-select [ngClass]="{'dropdown-disabled': createViaRunbook}" (closed)="dropdownClose()" class="runbook-dropdown pt-0" #matSelect [placeholder]="'INSTANCE_DETAILS.CHOOSE_ACTION' | transloco" [formControl]="runbookForm?.get('componentName')" panelClass="runbook-dropdown" (click)="resetFilter()" (selectionChange)="onActionSelected($event.value)" (selectionChange)="componentSelection($event)">
              <div *ngIf="!componentsLoading" class="flex search-bar m-8"><input [(ngModel)]="searchValue" (ngModelChange)="searchChanged(searchValue)" [ngModelOptions]="{standalone: true}" class="fw-400 h-34 no-border pl-12" placeholder="Search" type="text">
                <span (click)="searchChanged(searchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
              </div>
              <mat-option *ngIf="componentsLoading">
                <div class="flex items-center justify-center spinner-width mb-16 mt-16">
                  <mat-spinner class="mr-8" diameter="20"
                    color="primary"
                    mode="indeterminate">
                  </mat-spinner>
                </div>
              </mat-option>
              <mat-option class="fs-14 flex justify-center" *ngIf="!componentsLoading && filteredComponents?.length === 0">{{'INSTANCE_DETAILS.NO_ACTION_FOUND' | transloco}}</mat-option>
              <mat-option *ngFor="let component of filteredComponents" [value]="component">{{component.displayName}}</mat-option>
            </mat-select>
            </div>
            <app-error [control]="runbookForm?.get('componentName')"></app-error>
          </div>
          <div class="flex flex-col mb-24 mr-32">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.VERSION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.VERSION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div [ngClass]="{'input-disabled': createViaRunbook}">
            <mat-select [ngClass]="{'dropdown-disabled': createViaRunbook}" class="runbook-dropdown pt-0" #matSelect [placeholder]="'INSTANCE_DETAILS.CHOOSE_VERSION' | transloco" [formControl]="runbookForm?.get('componentVersion')">
              <mat-option class="fs-14 flex justify-center" *ngIf="versions?.length === 0">{{selectedComponent ? ('INSTANCE_DETAILS.NO_VERSION_FOUND' | transloco) : ('INSTANCE_DETAILS.CHOOSE_COMPONENT_TO_SEE_VERSIONS' | transloco)}}</mat-option>
              <mat-option *ngFor="let version of versions" [value]="version">{{version?.version}}</mat-option>
            </mat-select>
            </div>
            <app-error [control]="runbookForm?.get('componentVersion')"></app-error>
          </div>
        </div> -->
      </form>
    </div>
  }  @else if (currentStep === 2) {
    <div class="flex flex-col sumary-section mb-16 section-border p-16">
      <div class="flex flex-row justify-between mb-20">
        <div class="mat-subtitle-1 fs-16 fw-700 sub-header mb-0">{{ 'SCHEDULE_DETAILS.DETAIL' | transloco }}</div>
        <div class="flex justify-end cursor-pointer edit" (click)="goToStep(-1)">
          <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
          <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
        </div>
      </div>
      <div class="flex flex-row">
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'INSTANCE_DETAILS.NAME' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ detailsForm?.get('name')?.value }}</div>
        </div>
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ detailsForm?.get('description')?.value }}</div>
        </div>
      </div>
    </div>
    <div class="flex flex-col sumary-section mb-16 section-border p-16">
      <div class="flex flex-row justify-between mb-20">
        <div class="mat-subtitle-1 fs-16 fw-700 sub-header mb-0">{{ 'SCHEDULE_DETAILS.OCCURRENCE' | transloco }} - {{this.selectedFilter.label}}</div>
        <div class="flex justify-end cursor-pointer edit" (click)="goToStep(0)">
          <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
          <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-6 w-full mb-6">
        <div class="col-span-3">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TEST_RESULTS.TIMEZONE' | transloco | uppercase }}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ isAWS ? 'UTC' : (selectedTimezone?.displayName || '-') }}</div>
        </div>
        <div class="col-span-3">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.STARTDATE' | transloco | uppercase }}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ startTime ? (startTime | date: 'MMM dd yyyy, HH:mm:ss' : 'UTC') : '-'}}</div>
        </div>
        <div class="col-span-3">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.ENDDATE' | transloco | uppercase }}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ endTime ? (endTime |  date: 'MMM dd yyyy, HH:mm:ss' : 'UTC') : '-'}}</div>
        </div>              
        <div *ngIf="cronValue" class="col-span-3">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.CRON_EXP' | transloco | uppercase }}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ cronValue }}</div>
        </div>
        </div>
    </div>
    <div class="flex flex-col sumary-section mb-16 section-border p-16">
      <div class="flex flex-row justify-between mb-20">
        <div class="mat-subtitle-1 fs-16 fw-700 sub-header mb-0">{{ 'RUNBOOK.RUNBOOK' | transloco }}</div>
        <div class="flex justify-end cursor-pointer edit" (click)="goToStep(1)">
          <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
          <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
        </div>
      </div>
      <div class="flex flex-row">
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'RUNBOOK.RUNBOOK' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ runbookForm?.get('runbookName')?.value?.name }}</div>
        </div>
        <!-- <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'INSTANCE_DETAILS.ACTION' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ runbookForm?.get('componentName')?.value?.displayName}}</div>
        </div>
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'INSTANCE_DETAILS.VERSION' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ runbookForm?.get('componentVersion')?.value?.version }}</div>
        </div> -->
      </div>
    </div>
  }

  <div class="flex flex-row justify-end mt-32 mb-32">
    <div *ngIf="currentStep !== -1" class="flex justify-items-center items-center cursor-pointer mr-32" (click)="goToStep(currentStep - 1)">
      <mat-icon class="icon-sm mr-8" svgIcon="arrow_back"></mat-icon>
      <span class="mat-subtitle-2 fw-700 cursor-pointer">{{ 'BUTTONS.PREVIOUS' | transloco }}</span>
    </div>
    <button (click)="cancelClick()" class="flex justify-items-center items-center cancel-btn mr-16 pr-16 pl-16 pt-8 pb-8">
      {{ 'BUTTONS.CANCEL' | transloco }}
    </button>
    <button
      *ngIf="(currentStep === -1 || currentStep === 0 || currentStep === 1); else showSubmitButton"
      class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" type="button"
      (click)="goToStep(currentStep + 1)">{{ 'BUTTONS.NEXT' | transloco }}
    </button>
    <ng-template #showSubmitButton>
      <div class="button-container">
        <button class="flex justify-center items-center items-center mossgreen primary-fg" type="button" (click)="isEditFlow ? editSubmit() : submit()">
          <span>{{('BUTTONS.SUBMIT' | transloco)}}</span>
        </button>
      </div>
    </ng-template>
  </div>
</div>
